import React, { Component } from 'react'
import Iframe from 'react-iframe';
import { withRouter } from 'react-router-dom';

import {
  RoundedWrapper,
  IframeWrapper,
} from './styles'

const { REPORT_URL } = process.env

class ConformityReport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      navList: [
        'Task',
        'Task List Unconformity',
        'Unconformity Report',
      ],
    }
  }

  getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 384}px` : `${h - 300}px`
  }

  render() {
    const { match: { params: { taskId } } } = this.props
    const reportUri = `${REPORT_URL}CONFORMITY_REPORT&ISSUE_ID=${taskId}`

    return (
      <RoundedWrapper>
        <div className={'mt-3'}>
          <IframeWrapper>
            <Iframe
              url={reportUri}
              width="100%"
              height={this.getIframeHeight()}
              display="initial"
              position="relative"
              frameBorder="0"
            />
          </IframeWrapper>
        </div>
      </RoundedWrapper>
    )
  }
}

export default withRouter(ConformityReport)
